import {selectEventHasAdditionalLinks} from '~/common/event/eventAttributes/reducer';
import {selectHasGuestsOfHonor, selectRsvpOff} from '~/common/fabric/reducers/details/selectors';
import {
  selectCharityID,
  selectCrowdfundPurpose,
  selectHostPhotoGalleryEnabled,
  selectPhotosEnabled,
  selectRegistryUrls,
  selectShowGifting,
} from '~/common/fabric/reducers/giftingOptions/selectors';
import {EventFeature} from '~/common/types/event';

export const selectIsMealOptionsEventType = ({details}) => {
  if (details?.type) {
    const isMealOptionsOnViewInvitation = window.mealOptionsEventTypes?.[0].includes(details.type);
    const isMealOptionsOnCreateFlow = window.mealOptionsEventTypes?.includes(details.type);
    return Boolean(isMealOptionsOnViewInvitation || isMealOptionsOnCreateFlow);
  }
  return false;
};

export const selectHasPoll = ({widgets}) => Boolean(widgets?.polls?.length);

export const selectHasWtb = ({widgets}) => Boolean(widgets?.whatToBrings?.length);

export const selectPolls = (state) => state.widgets.polls;
export const selectWhatToBrings = (state) => state.widgets.whatToBrings;

export const selectActiveModules = (state) => {
  const modules = [];
  if (selectHostPhotoGalleryEnabled(state)) modules.push(EventFeature.HOST_PHOTO_GALLERY);
  if (selectPhotosEnabled(state)) modules.push(EventFeature.PHOTO_SHARING);
  if (selectHasGuestsOfHonor(state)) modules.push(EventFeature.GUESTS_OF_HONOR);
  if (selectHasWtb(state)) modules.push(EventFeature.WHAT_TO_BRING);
  if (selectRsvpOff(state) || selectHasPoll(state)) modules.push(EventFeature.POLLS);
  if (selectEventHasAdditionalLinks(state)) modules.push(EventFeature.ADDITIONAL_LINKS);
  const registryUrls = selectRegistryUrls(state);
  if (registryUrls && registryUrls.length > 0) modules.push(EventFeature.WISHLIST);
  if (selectShowGifting(state)) modules.push(EventFeature.GIFT_IDEAS);
  if (selectCharityID(state)) modules.push(EventFeature.CHARITY);
  if (selectCrowdfundPurpose(state)) modules.push(EventFeature.CROWDFUNDING);
  return modules;
};
